import { render, staticRenderFns } from "./IconWorkDay.vue?vue&type=template&id=9322b5ba&"
import script from "./IconWorkDay.vue?vue&type=script&lang=js&"
export * from "./IconWorkDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports